/*
 * @FilePath: /kitchen-offline-web/src/3DEngine/render/room/wall.ts
 * @Author: Yongchao Wang
 * @Date: 2021-12-14 17:10:33
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-05-09 17:40:50
 * @Description:
 */
import { Mesh } from '@babylonjs/core/Meshes/mesh';
import { Constants, PBRMetallicRoughnessMaterial, Texture, Vector3, } from '@babylonjs/core';
import { VertexData } from '@babylonjs/core/Meshes/mesh.vertexData';
export default class Wall {
    constructor(scene) {
        this.scene = scene;
        this.size = { width: 0, height: 0 };
    }
    /**
     * @description: 创建墙并进行旋转
     * @param {WallSegmentNode} nodeWall 墙的node描述
     * @param {Rotation} rotation 旋转角度
     * @param {Position} position 位置
     * @return {*}
     * @author: Yongchao Wang
     */
    createWall(nodeWall, rotation, position) {
        const positions = [
            nodeWall.toPoint.x,
            nodeWall.toPoint.y,
            nodeWall.toPoint.z,
            nodeWall.fromPoint.x,
            nodeWall.wallHeight,
            nodeWall.fromPoint.z,
            nodeWall.fromPoint.x,
            nodeWall.fromPoint.y,
            nodeWall.fromPoint.z,
            nodeWall.toPoint.x,
            nodeWall.wallHeight,
            nodeWall.toPoint.z,
            nodeWall.fromPoint.x,
            nodeWall.wallHeight,
            nodeWall.fromPoint.z,
            nodeWall.toPoint.x,
            nodeWall.toPoint.y,
            nodeWall.toPoint.z,
        ];
        const customMesh = new Mesh(nodeWall.name, this.scene);
        // Create a vertexData object
        const vertexData = new VertexData();
        const indices = [0, 1, 2, 3, 4, 5];
        // Empty array to contain calculated values or normals added
        const normals = [];
        // Calculations of normals added
        VertexData.ComputeNormals(positions, indices, normals);
        vertexData.positions = positions;
        vertexData.indices = indices;
        vertexData.normals = normals; // Assignment of normal to vertexData added
        vertexData.uvs = [1, 0, 0, 1, 0, 0, 1, 1, 0, 1, 1, 0];
        vertexData.applyToMesh(customMesh);
        customMesh.addRotation(rotation.x, rotation.y, rotation.z);
        customMesh.position = new Vector3(position.x, position.y, position.z);
        this.size = { width: Math.abs(nodeWall.toPoint.x - nodeWall.fromPoint.x), height: nodeWall.wallHeight };
        this.rotation = rotation;
        this.position = position;
        this.wallMesh = customMesh;
    }
    changeMatrial(wallTextureUrl, wallNormalTextureUrl, size = { width: 0.08, height: 0.08 }) {
        var _a, _b;
        if (!this.wallMesh) {
            return;
        }
        let material = (_a = this.wallMesh) === null || _a === void 0 ? void 0 : _a.material;
        if (!((_b = this.wallMesh) === null || _b === void 0 ? void 0 : _b.material)) {
            material = new PBRMetallicRoughnessMaterial('wallMaterial', this.scene);
        }
        const uscale = this.size.width / size.width;
        const vscale = this.size.height / size.height;
        const floorTexture = new Texture(wallTextureUrl, this.scene, false, false, Constants.TEXTURE_TRILINEAR_SAMPLINGMODE, () => {
            floorTexture.uScale = uscale;
            floorTexture.vScale = vscale;
            material.baseTexture = floorTexture;
        });
        const floorNormalTexture = new Texture(wallNormalTextureUrl, this.scene, false, false, Constants.TEXTURE_TRILINEAR_SAMPLINGMODE, () => {
            floorNormalTexture.uScale = uscale;
            floorNormalTexture.vScale = vscale;
            material.normalTexture = floorNormalTexture;
        });
        this.wallMesh.material = material;
    }
}
